import { formatDate } from "common/service/CommonService";
import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

export const templateColumns: any[] = [
  {
    label: "Template Name",
    key: "templatename",
    tooltip: true,
  },
  {
    label: "Created Date",
    key: "createddate",
    render: (value: any) => (value ? formatDate(value) : ""),
  },
];


export const formFields: FormFieldConfig[] = [
  {
    name: "templateName",
    label: "Template Name",
    placeholder: "Enter template name",
    type: "text",
    required: true,
    rules: validations.template.name,
  }
];